module.exports = __webpack_public_path__ + "img/software.c3921f32.svg";